import { render, staticRenderFns } from "./ClickDetail.vue?vue&type=template&id=2e6171d6&scoped=true&"
import script from "./ClickDetail.vue?vue&type=script&lang=ts&"
export * from "./ClickDetail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e6171d6",
  null
  
)

export default component.exports